import SelectComponent from './Select.component';

export * from './Select.component';
export default SelectComponent;
